/**
 * Given an array of strings, return a plain-english list.
 *
 * @param {array} list List of strings to join.
 *
 * @returns {String} Returns a formatted string.
 *
 * @example
 *
 * listify(['Larry', 'Moe', 'Curly'], 'y')
 * // => 'Larry, Moe, y Curly'
 *
 */

export let listify = (array: string[] = [], and = 'and'): string => {
  switch (array.length) {
    case 0:
      return '';
    case 1:
      return array[0];
    case 2:
      return `${array[0]} ${and} ${array[1]}`;
    default:
      return `${array
        .slice(0, array.length - 1)
        .join(', ')}, ${and} ${array.slice(-1)}`;
  }
};
